import WebkitCallback from '@/lib/webkit-callback';
var EventApiRender = {
  completed: function completed() {
    WebkitCallback.renderCompleted();
  }
};
export default EventApiRender;